app.service('scrollTop',function(front,html){
	let $self;
	let pageTopScrollerEnabled = true;
	let pageTopScrollerThreshold = 200;

	function init() {
		const threshold = $(document).height() / $(window).height() >= 3;
		const isNotBottomButtonPresent = $('#product-buttons-fixed').length === 0;

		if(front.page() !== "product"){
			pageTopScrollerEnabled = threshold;
		}
		else {
			pageTopScrollerEnabled = threshold && isNotBottomButtonPresent;
		}

		setElements();
		setEvents();
	}

	function setElements(){
		$self = $('#scroll-top');
	}
	function setEvents(){
		
		$self.on('click', function (e) {
			e.preventDefault();
			$('body,html').animate({ scrollTop: 0 }, 500);
			$('#header-skip-links li:first-of-type a').focus();
		});
		$self.on('keydown', function (e) { // prevent scrolling when using space
			if ([' '].includes(e.key)) {
				e.preventDefault();
				e.stopPropagation();
			}
		});
		$self.on('keyup', function (e) {
			if ([' '].includes(e.key)) {
				e.preventDefault();
				e.stopPropagation();
				$(e.target).trigger('click');
			}
		});

		if(pageTopScrollerEnabled){
			html.add('scrollTop-enabled');
			$(window).on('scroll', function(){
				scroll();
			});
		}
		$(window).on('orientationchange',function(){
			init();
		});
	}
	function scroll(){
		if( $(window).scrollTop() > pageTopScrollerThreshold){
			html.add('scrollTop-visible');
		}
		else {
			html.remove('scrollTop-visible');
		}
	}
	return {
		init:init
	};
});
